import { render } from "./Footer.vue?vue&type=template&id=c0a04d1c"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=c0a04d1c&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/Users/mac_2/workspace/jukebox-goass/_neu/goass-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__